import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { API_URL_INTEGRATION_USER_SETTINGS } from "constants/api_urls";
import { IntegrationUserSettingsResponse } from "interfaces/integration-user-settings";

export const useIntegrationUserSettingsQuery = (): UseQueryResult<
  IntegrationUserSettingsResponse,
  unknown
> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["integrationUserSettings"],
    queryFn: async () => {
      const { data } = await axios.get<IntegrationUserSettingsResponse>(
        API_URL_INTEGRATION_USER_SETTINGS
      );
      return data;
    }
  });
};
